import React from 'react';
import BlogLeftSideBar from '../../Blogs/BlogsArea/BlogLeftSideBar';

const BlogDetailsArea = ({ blog }) => {
   return (
      <>
         <section className="blog__area pt-120 pb-120">
            <div className="tw-container tw-mx-auto">
               <div className="tw-flex tw-flex-wrap tw--mx-3">
                  <div className="tw-w-full tw-px-3 lg:tw-w-2/3">
                     <div className="blog__details-wrapper mr-50">
                        <div className="blog__details-thumb w-img mb-45">
                           <img src={blog.image} alt="" />
                        </div>
                        <div className="blog__text mb-45">
                           <div
                              dangerouslySetInnerHTML={{
                                 __html: blog?.content || "",
                              }}
                              className="blog-content-text"
                           />
                        </div>
                     </div>
                  </div>

                  <BlogLeftSideBar />
               </div>
            </div>
         </section>
      </>
   );
};

export default BlogDetailsArea;